import { Controller } from '@hotwired/stimulus'

// Hides the page-level "Results are being processed" banner once processing
// has visibly finished. Frames lazy-load, so skeletons below the fold may
// never load at all — the banner must NOT wait for them. It hides when BOTH:
//   1. at least one frame has real content (data-results-ready) — proof the
//      backend is now serving finished results, and
//   2. no frame is actively warming (data-results-pending, set only by
//      poll-mode skeletons returned from the fragment endpoint).
export default class extends Controller<HTMLElement> {
  static values = {
    interval: { type: Number, default: 2000 },
  }

  declare readonly intervalValue: number

  private timer?: ReturnType<typeof setInterval>

  connect(): void {
    this.timer = setInterval(() => this.checkPending(), this.intervalValue)
  }

  disconnect(): void {
    if (this.timer) clearInterval(this.timer)
  }

  private checkPending(): void {
    if (!document.querySelector('[data-results-ready]')) return
    if (document.querySelector('[data-results-pending]')) return

    if (this.timer) clearInterval(this.timer)
    this.element.hidden = true
  }
}
